import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { DownloadIcon } from 'foundations-assets/icons/components/DownloadIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { useTicketListingsSortAndFilters } from '../hooks/useTicketListingsSortAndFilters';
import { useCsvExport } from '../data/useCsvExport';
import { useIsPreview } from '../hooks/useIsPreview';
import { usageTracker } from '../utils/usageTracker';
import { useIsMobile } from '../hooks/useBreakpoint';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function CsvExportButton() {
  const {
    sort,
    ticketView,
    statusFilter,
    searchString,
    createDateFilter,
    lastActivityFilter
  } = useTicketListingsSortAndFilters();
  const csvExport = useCsvExport({
    sort,
    ticketView,
    statusFilter,
    searchString,
    createDateFilter,
    lastActivityFilter
  });
  const isPreview = useIsPreview();
  const isMobile = useIsMobile();
  return /*#__PURE__*/_jsxs(LoadingButton, {
    "data-test-id": 'csv-export-button',
    marginInline: "0",
    size: "small",
    onClick: () => {
      if (isPreview) return;
      usageTracker.track('Customer Portal App', 'Tickets Discovered', {
        action: 'tickets-exported',
        screen: 'ticket-listings'
      });
      csvExport.doExport();
    },
    use: "secondary-alt",
    loading: csvExport.loading,
    failed: !!csvExport.error,
    "aria-label": I18n.text('customer-portal-app.ticketListings.export.button'),
    children: [/*#__PURE__*/_jsx(DownloadIcon, {}), !isMobile && /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customer-portal-app.ticketListings.export.button"
    })]
  });
}